import { IConfiguration } from "./IConfiguration"

export const CurrentEnvironment='assets/json/env.json'

export const Configuration:any=null